import { queryOptions } from '@tanstack/react-query';
import { getAdjusterRankChartFunction } from './getAdjusterRankChartQueryFunction';

export const getAdjusterRankChartQueryOptions = () => {
  return queryOptions({
    queryKey: ['AdjusterRankChart'],
    queryFn: () => getAdjusterRankChartFunction(),
  });
};
